import styled from 'styled-components';
import { spacer32 } from '@spotify-internal/encore-web';
import { BREAKPOINT_SMALL } from 'client/components/MarketingPagesShared/styles';
import { MarketingButton } from 'client/components/MarketingPagesShared/MarketingButton';
import { HomeSection } from '../../../styles';
import { CDN_PATH } from '../../../constants';

export const HomeInspirationBackground = styled.div`
  background-image: url(${CDN_PATH}/bg-inspiration.svg);
  background-repeat: repeat-x;
`;

export const HomeInspirationSection = styled(HomeSection)`
  && {
    display: grid;
    grid-template-columns: 40% calc(60% - 46px);
    grid-column-gap: 45px;
    grid-row-gap: 45px;
    align-items: center;
    min-height: 640px;
    padding-right: 0;

    @media (max-width: ${BREAKPOINT_SMALL}px) {
      grid-template-columns: 1fr;
      grid-template-rows: auto;
      padding: 0 26px 175px;
    }
  }
`;

export const HomeSectionSubtitle = styled.p`
  margin-bottom: ${spacer32};
  max-width: 408px;
  font-size: 1.25rem;
  color: white;
`;

export const HomeInspirationImageColumn = styled.div`
  & > div {
    background: transparent;
  }
`;

export const StyledMarketingButton = styled(MarketingButton)`
  width: 252px;
  @media (max-width: ${BREAKPOINT_SMALL}px) {
    width: 100%;
  }
`;
